var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"text-align":"center","padding-top":"80px"}},[_vm._v("Return to the app to view the results.")]),_c('button',{staticStyle:{"margin":"20px auto","display":"block","color":"#fff","background":"#409EFF","border-color":"#409EFF"},on:{"click":_vm.openApp}},[_vm._v("OPEN APP")])])
}
var staticRenderFns = []

export { render, staticRenderFns }